import { Heading } from 'app/agriculture/components/Heading/Heading';
import { RoundTable } from 'app/agriculture/components/RoundTable/RoundTable';
import { formatDistanceToNow, isAfter, subDays } from 'date-fns';
import { IconButton } from 'app/agriculture/components/Button/Button';
import { DeleteIcon, RefreshIcon } from 'app/agriculture/icons';
import { useFarmInvitations } from 'app/agriculture/queries/invitations/useFarmInvitations';
import { useInvitationResendMutation } from 'app/agriculture/mutations/invitations/useInvitationResendMutation';
import { useInvitationDismissMutation } from 'app/agriculture/mutations/invitations/useInvitationDismissMutation';

export function FarmInvitations() {
    const invitations = useFarmInvitations();
    const { mutate: resendInvitation } = useInvitationResendMutation();
    const { mutate: dismissInvitation } = useInvitationDismissMutation();

    if (invitations.length === 0) return null;

    return (
        <>
            <Heading>Outstanding Invitations</Heading>
            <RoundTable
                columns={{
                    email: { label: 'Email', width: 'minmax(auto, 2fr)' },
                    sent: { label: 'Sent' },
                    status: { label: 'Status', width: '120px' },
                    resend: { label: '', width: 'min-content' },
                    dismiss: { label: '', width: 'min-content' },
                }}
                rows={invitations.map((invitation) => ({
                    id: invitation.id,
                    email: invitation.email,
                    sent: formatDistanceToNow(invitation.createdAt, { addSuffix: true }),
                    status: invitation.status,
                    resend: (
                        <IconButton
                            icon={<RefreshIcon />}
                            tooltip="Resend"
                            variant="textonly"
                            disabled={
                                invitation.status === 'Rejected' ||
                                isAfter(invitation.createdAt, subDays(new Date(), 1))
                            }
                            onClick={() => {
                                resendInvitation(invitation);
                            }}
                        />
                    ),
                    dismiss: (
                        <IconButton
                            icon={<DeleteIcon />}
                            tooltip="Dismiss"
                            variant="textonly"
                            onClick={() => {
                                dismissInvitation(invitation);
                            }}
                        />
                    ),
                }))}
            />
        </>
    );
}
